import { truncateFloat } from "../../helpers/generalHelper";
import { Clock, Task, ReloadArrow, PencilSquare, Trash } from "../icons";

export const ContainerCardsAreas = ({ datas = [], callReload, callEdit, callDelete, hasAction }) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 mx-auto text-[10px]">
            {datas.map((data, key) => {
                const {
                    name,
                    color: backgroundColor = "#000",
                    totalTimeSpent,
                    installedCapacity,
                    lists,
                    percentTotalSection
                } = data;
                return (
                    <article key={`${key}--data-section`} className="border-2 border-[#EFF2F5] [break-inside:avoid-column] rounded-md mb-4">
                        <header className="flex justify-between px-3 py-2 bg-[#EFF2F5]">
                            <div className="flex justify-center items-center gap-3">
                                <div className="w-4 h-4 rounded-full" style={{ backgroundColor }} />
                                <p className="text-xs font-bold uppercase">{name}</p>
                            </div>
                            <div className="flex justify-center items-center gap-3">
                                {hasAction && (
                                    <div onClick={() => { callDelete(data) }} className="w-5 h-5 rounded-sm cursor-pointer">
                                        <Trash />
                                    </div>
                                )}
                                <div onClick={() => { callReload(data) }} className="w-5 h-5 rounded-sm cursor-pointer">
                                    <ReloadArrow />
                                </div>
                                {hasAction && (
                                    <div onClick={() => { callEdit(data) }} className="w-5 h-5 rounded-sm cursor-pointer">
                                        <PencilSquare />
                                    </div>
                                )}
                            </div>
                        </header>
                        <div className="p-4">
                            <div className="mb-4 flex flex-col gap-2">
                                <div className="flex justify-start items-center gap-2">
                                    <Task />
                                    <p className="font-bold">
                                        Capacidad Instalada: <span className="ml-2 font-normal">{truncateFloat(installedCapacity)}</span>{" "}
                                    </p>
                                </div>
                                <div className="flex justify-start items-center gap-2">
                                    <Clock />
                                    <p className="font-bold">
                                        Horas Totales: <span className="ml-2 font-normal">{truncateFloat(totalTimeSpent)}</span>
                                    </p>
                                </div>
                                <div className="flex justify-start items-center gap-2">
                                    <Clock />
                                    <p className="font-bold">
                                        Porcentaje Total: <span className="ml-2 font-normal">{truncateFloat(percentTotalSection)} %</span>
                                    </p>
                                </div>
                            </div>
                            <div className="flex flex-col gap-2 overflow-y-auto max-h-[300px]">
                                <div className="grid grid-cols-3 font-bold">
                                    <p className="col-span-1">Listas</p>
                                    <p className="col-span-1">No. de horas</p>
                                    <p className="col-span-1">Horas vs capacidad %</p>
                                </div>

                                {lists.map((list, key1) => {
                                    const { listRoot: { folder, space } } = list;
                                    return (
                                        <div key={`${key1}--lists`} className="grid grid-cols-3 py-2 border-t border-[#383838]">
                                            <p className="col-span-1 flex flex-col gap-1">
                                                <span className="font-semibold text-[10px]">{list.name}</span>
                                                <span className="text-[#000] text-[8px]">Space: {space?.name} </span>
                                                <span className="text-[#000] text-[8px]">Folder: {folder?.name || "N/A"}</span>
                                            </p>
                                            <p className="col-span-1 self-center justify-self-center">{truncateFloat(list.totalTimeSpent)}</p>
                                            <p className="col-span-1 self-center justify-self-center">{truncateFloat(list.percentList)} %</p>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </article>
                );
            })}
        </div>
    );
};
